export default __webpack_public_path__ + "538d829fd8a1a85de85f07f52a8de22c.svg";